import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { initializeAuthSDK } from '@xinchuantw/auth-react';
import { Toaster } from 'react-hot-toast';
import AntdConfigProvider from './providers/AntdConfigProvider';
import { config } from './config/env';
import './index.css';
import './lib/datetime';
import App from './App.tsx';
import './i18n.js';

// Calls auth-api directly (no proxy/BFF) — the SDK resolves the auth API URL
// from `env`, and the auth API's CORS config allows the frontend origins.
initializeAuthSDK({
  env: config.environment,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AntdConfigProvider>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AntdConfigProvider>
  </StrictMode>
);
